import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import EmptyView from 'general/components/Others/EmptyView';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import Utils from 'general/utils/Utils';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import AppColors from 'general/constants/AppColors';
import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import AgencySaleCreateAppendixView from '../FleetCreateAppendixView';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import useAppConfig from 'hooks/useAppConfig';
import AppConfigs from 'general/constants/AppConfigs';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import FleetHelper from 'features/Fleet/fleetHelper';

AppendicesListView.propTypes = {
    agencyId: PropTypes.string,
    primaryRole: PropTypes.string,
    appendicesList: PropTypes.array,
    onRefresh: PropTypes.func,
    contractId: PropTypes.number,
};

function AppendicesListView(props) {
    // ---- params ----
    const appConfig = useAppConfig();
    const { agencyId, primaryRole, appendicesList, onRefresh = () => { }, contractId } = props;
    const { user } = useSelector((state) => state.auth);
    const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
    const isBuyer = user?.role === 'AGENCY' && user?.agency?.primaryRole === 'INVESTOR';
    const fullColumns = useMemo(() => {
        return [
            {
                name: UIHelper.buildTableColumn('Số phụ lục'),
                selector: (row) => row?.appendixNumber,
                minWidth: '120px',
                style: tableStyle.columns.normal,
                sortable: true,
            },
            {
                name: UIHelper.buildTableColumn('Loại phụ lục'),
                selector: (row) =>
                    _.find(AgencyHelper.Data.appendixTypeOptions, (item) => item.value === row?.appendixType)
                        ?.name,
                minWidth: '120px',
            },
            {
                name: UIHelper.buildTableColumn('Tên phụ lục'),
                minWidth: '210px',
                selector: (row) => row?.appendixName,
            },
            {
                name: UIHelper.buildTableColumn('Ngày phụ lục'),
                selector: (row) => Utils.formatDateTimeToString(row?.appendixDate, 'DD/MM/YYYY'),
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '110px',
            },
            {
                name: UIHelper.buildTableColumn('Nội dung điều chỉnh'),
                selector: (row) => row?.description,
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '220px',
            },
            {
                name: UIHelper.buildTableColumn('Trạng thái'),
                selector: (row) => (
                    <KTLabel
                        text={AgencyHelper.Utils.getContractStatusName(row?.status)}
                        isInline={true}
                        size={KTLabelSize.medium}
                        additionalClassName={`label-light-${AgencyHelper.Utils.getContractStatusColor(
                            row?.status
                        )}`}
                        additionalDescription={row?.cancelingReason}
                    />
                ),
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '150px',
            },
            {
                name: UIHelper.buildTableColumn('Thao tác'),
                style: tableStyle.columns.normal,
                sortable: false,
                width: '140px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                cell: (row) => {
                    return UIHelper.buildMoreActionsButton(buildMoreActionsAppendix(row), true);
                },
            },
        ];
    }, []);
    // ---- methods ----

    const handleSignAppendix = (row) => {
        AppCustomDialogHelper.show(
            '',
            <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogSignContract} />}
                title="Ký phụ lục hợp đồng"
                contentEl={
                    <>
                        Bạn muốn ký phụ lục hợp đồng:{' '}
                        <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                            {row?.appendixName}
                        </span>
                        ?
                    </>
                }
                showInput={!isAdmin}
                inputLabel={['Định danh chữ ký số (UUID)', 'Nhập mật khẩu']}
                inputType={['text', 'password']}
                showAdditionalInfo={!isAdmin}
                additionalInfo={
                    <div
                        className="d-flex gap-3 p-3 align-items-center"
                        style={{
                            border: `1px dashed ${AppColors.danger}`,
                            backgroundColor: '#FFF6F6',
                        }}
                    >
                        <div className="w-32px h-32px rounded-circle bg-danger-o-20 d-flex align-items-center justify-content-center">
                            <i className="fas fa-signature" style={{ color: AppColors.danger }} />
                        </div>
                        <div className="d-flex flex-column">
                            <div style={UIHelper.buildFontStyle('700', '20px', AppColors.danger)}>
                                Bạn chưa có chữ ký số?
                            </div>
                            <div>
                                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                                    Vui lòng tạo chữ ký số{' '}
                                </span>
                                <a
                                    href={'#'}
                                    target={'_blank'}
                                    style={UIHelper.buildFontStyle('700', '14px', AppColors.danger)}
                                >
                                    tại đây
                                </a>
                            </div>
                        </div>
                    </div>
                }
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
                onConfirm={async (values) => {
                    let hsmAgreementUUID = null;
                    let hsmPassword = null;
                    if (!isAdmin) {
                        [hsmAgreementUUID, hsmPassword] = values;
                    }
                    const updatedAppendices = [...(appendicesList || [])];
                    const appendixIndex = updatedAppendices.findIndex(appendix => appendix?.index === row?.index);
                    if (appendixIndex !== -1) {
                        updatedAppendices[appendixIndex] = {
                            ...updatedAppendices[appendixIndex],
                            status: isAdmin ? AgencyConstants.AppendixStatus.ADMIN_SIGNED : AgencyConstants.AppendixStatus.COMPLETED,
                        };
                    } else {
                        ToastHelper.showError('Không tìm thấy phụ lục để cập nhật');
                        return;
                    }

                    const fileName = await Utils.getFileNameFromPath(row?.appendixDocument);
                    const fileItem = await Utils.urlToFile(`${AppConfigs.env.domainUrl}/${row?.appendixDocument}`, fileName);

                    const formData = new FormData();
                    formData.append('file', fileItem);
                    formData.append('hsmAgreementUUID', isAdmin ? appConfig.adminAgreementUUID : hsmAgreementUUID);
                    formData.append('hsmPasscode', isAdmin ? appConfig.adminPasscode : hsmPassword);
                    formData.append('page', 'LAST');
                    formData.append('anchor', isAdmin ? 'ĐẠI DIỆN BÊN A' : 'ĐẠI DIỆN BÊN B');

                    const { url, file } = await AgencyHelper.API.requestSignDocument(formData);
                    const urlFile = url && _.isString(url) ? url : file;

                    if (urlFile && _.isString(urlFile)) {
                        const relativeUrl = urlFile.replace(AppConfigs.env.domainUrl + '/', '');
                        updatedAppendices[appendixIndex] = {
                            ...updatedAppendices[appendixIndex],
                            appendixDocument: relativeUrl,
                        }
                        const result = await FleetHelper.API.requestUpdateContract(
                            contractId,
                            { appendices: updatedAppendices }
                        );
                        if (_.isObject(result)) {
                            ToastHelper.showSuccess('Cập nhật phụ lục hợp đồng thành công');
                            if (onRefresh) {
                                onRefresh();
                            }
                            AppCustomDialogHelper.hide();
                        } else {
                            ToastHelper.showError(result || 'Cập nhật phụ lục hợp đồng không thành công');
                        }
                    }
                }}
            />,
            'md',
            false,
            true
        );
    };

    const buildMoreActionsAppendix = (row) => {
        const actions = [];
        actions.push({
            text: 'Xem chi tiết',
            iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
            click: () => {
                if (Utils.isValid(row?.appendixDocument)) {
                    Utils.openInNewTab(Utils.getFullUrl(row?.appendixDocument));
                }
            },
        });
        if (isAdmin) {
            // ky hop dong
            if (row?.status === AgencyConstants.AppendixStatus.CREATED) {
                actions.push({
                    text: 'Ký phụ lục',
                    iconElement: (
                        <i className="fa-regular fa-file-signature" style={{ fontSize: '1.1rem' }} />
                    ),
                    click: () => {
                        handleSignAppendix(row);
                    },
                });
            }
            // chinh sua
            actions.push({
                text: 'Chỉnh sửa',
                iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
                click: () => {
                    AppCustomDialogHelper.show(
                        'Chỉnh sửa phụ lục hợp đồng',
                        <AgencySaleCreateAppendixView
                            appendixDetail={row}
                            appendicesList={appendicesList}
                            onCancel={() => {
                                AppCustomDialogHelper.hide();
                            }}
                            onConfirm={async (param) => {
                                const updatedAppendices = [...(appendicesList || [])];
                                const appendixIndex = updatedAppendices.findIndex(appendix => appendix?.index === row?.index);

                                if (appendixIndex !== -1) {
                                    updatedAppendices[appendixIndex] = {
                                        ...updatedAppendices[appendixIndex],
                                        appendixType: param.appendixType,
                                        appendixName: param.appendixName,
                                        appendixNumber: param.appendixNumber,
                                        appendixDate: param.appendixDate,
                                        description: param.description,
                                        appendixDocument: param.appendixDocument
                                    };
                                } else {
                                    ToastHelper.showError('Không tìm thấy phụ lục để cập nhật');
                                    return;
                                }

                                const result = await FleetHelper.API.requestUpdateContract(
                                    contractId,
                                    { appendices: updatedAppendices }
                                );

                                if (_.isObject(result)) {
                                    ToastHelper.showSuccess('Cập nhật phụ lục hợp đồng thành công');
                                    if (onRefresh) {
                                        onRefresh();
                                    }
                                    AppCustomDialogHelper.hide();
                                } else {
                                    ToastHelper.showError(result || 'Cập nhật phụ lục hợp đồng không thành công');
                                }
                            }}
                        />,
                        'lg',
                        false,
                        true
                    );
                },
            });
            if (
                row?.status !== AgencyConstants.AppendixStatus.CANCELLED
            ) {
                actions.push({
                    text: 'Hủy phụ lục',
                    iconElement: <i className="fa-regular fa-circle-xmark" style={{ fontSize: '1.1rem' }} />,
                    click: () => {
                        AppCustomDialogHelper.show(
                            '',
                            <AgencySaleDialogView
                                iconEl={<img src={AppResource.images.dialogIcons.dialogError} />}
                                title="Hủy phụ lục"
                                contentEl={
                                    <>
                                        Nhập lý do hủy phụ lục {' '}
                                        <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                            {row?.appendixName}
                                        </span>
                                    </>
                                }
                                inputLabel={['Lý do']}
                                showInput={true}
                                onCancel={() => {
                                    AppCustomDialogHelper.hide();
                                }}
                                onConfirm={async (values) => {
                                    const [cancelingReason] = values;
                                    const updatedAppendices = [...(appendicesList || [])];
                                    const appendixIndex = updatedAppendices.findIndex(appendix => appendix?.index === row?.index);
                                    if (appendixIndex !== -1) {
                                        updatedAppendices[appendixIndex] = {
                                            ...updatedAppendices[appendixIndex],
                                            status: AgencyConstants.AppendixStatus.CANCELLED,
                                            cancelingReason,
                                        };
                                    } else {
                                        ToastHelper.showError('Không tìm thấy phụ lục để cập nhật');
                                        return;
                                    }

                                    const result = await FleetHelper.API.requestUpdateContract(
                                        contractId,
                                        { appendices: updatedAppendices }
                                    );
                                    if (_.isObject(result)) {
                                        ToastHelper.showSuccess('Hủy phụ lục hợp đồng thành công');
                                        if (onRefresh) {
                                            onRefresh();
                                        }
                                        AppCustomDialogHelper.hide();
                                    } else {
                                        ToastHelper.showError(result || 'Hủy phụ lục hợp đồng không thành công');
                                    }
                                }}
                                confirmButtonRed={true}
                            />,
                            'md',
                            false,
                            true
                        );
                    },
                });
            }
            if (AgencyHelper.Utils.checkContractCanDelete(row?.status)) {
                actions.push({
                    text: 'Xóa phụ lục',
                    iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
                    click: () => {
                        AppCustomDialogHelper.show(
                            '',
                            <AgencySaleDialogView
                                iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
                                title="Xóa phụ lục"
                                contentEl={
                                    <>
                                        Bạn có chắc muốn xóa phụ lục:{' '}
                                        <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                            {row?.appendixName}
                                        </span>
                                        ?
                                    </>
                                }
                                onCancel={() => {
                                    AppCustomDialogHelper.hide();
                                }}
                                onConfirm={async () => {
                                    let updatedAppendices = [...(appendicesList || [])];
                                    updatedAppendices = updatedAppendices?.filter((appendix) => appendix?.index !== row?.index);

                                    const result = await FleetHelper.API.requestUpdateContract(
                                        contractId,
                                        { appendices: updatedAppendices }
                                    );

                                    if (_.isObject(result)) {
                                        ToastHelper.showSuccess('Xóa phụ lục hợp đồng thành công');
                                        if (onRefresh) {
                                            onRefresh();
                                        }
                                        AppCustomDialogHelper.hide();
                                    } else {
                                        ToastHelper.showError(result || 'Xóa phụ lục hợp đồng không thành công');
                                    }
                                }}
                                confirmButtonRed={true}
                            />,
                            'md',
                            false,
                            true
                        );
                    },
                });
            }
        } else {
            if (row?.status === AgencyConstants.AppendixStatus.ADMIN_SIGNED) {
                actions.push({
                    text: 'Ký phụ lục',
                    iconElement: (
                        <i className="fa-regular fa-file-signature" style={{ fontSize: '1.1rem' }} />
                    ),
                    click: () => {
                        handleSignAppendix(row);
                    },
                });
            }
        }
        return actions;
    };

    return (
        <div>
            {/* Body */}
            <div className="p-4">
                <KTTable
                    columns={fullColumns}
                    items={appendicesList}
                    selectableRows={false}
                    striped={false}
                    compactGrid={false}
                    onClickedRow={() => { }}
                    onSelectedRowsChanged={(rows) => { }}
                    onDoubleClickedRow={(rows) => { }}
                    noDataComponent={
                        <EmptyView
                            icon={imgEmptyNoData}
                            title="Không có dữ liệu để hiển thị"
                            text={
                                <div className="text-center">
                                    <span>
                                        Hiện không có dữ liệu để hiển thị. Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.
                                    </span>
                                </div>
                            }
                        />
                    }
                />
            </div>
        </div>
    );
}

export default AppendicesListView;
